import React, { useEffect, useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
// import Share from "yet-another-react-lightbox/plugins/share";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { useGalleryImageContext } from "../../context/GalleryImageContext";
import { formatDateDetails } from "../../exports/functions";
import { useLoader } from "../../context/LoaderContext";
import { Fade } from "react-awesome-reveal";
interface IGalleryID {
  id: number;
}

const GalleryImage = (props: IGalleryID) => {
  const { loading } = useLoader();
  const [open, setOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const galleryGridRef = useRef<HTMLDivElement>(null);
  const { galleryImageData } = useGalleryImageContext();
  const images = galleryImageData?.map((data) => {
    return {
      id: data?.id,
      title: data?.attributes?.Title,
      Date: data?.attributes.Date,
      image: data?.attributes?.Images?.data?.map((img) => img?.attributes?.url),
    };
  });
  const filteredGallery = images.find((img) => img.id === props.id);
  const formatedDate = formatDateDetails(filteredGallery?.Date || "");

  useEffect(() => {
    if (props.id !== undefined) {
      galleryGridRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [props.id]);

  if (!filteredGallery) {
    return <p>No gallery found for this ID.</p>;
  }

  const lightboxSlides = filteredGallery.image.map((src) => ({
    src: `${process.env.REACT_APP_strapiUrl}${src}`,
  }));
  const handleSlideClick = (index: number) => {
    setLightboxIndex(index);
    setOpen(true);
  };
  return (
    <>
      <div ref={galleryGridRef}></div>
      <section className="events-page">
        <div className="container">
          <div className="section-title custom-text-center">
            <span className="section-title__tagline">
              {formatedDate?.Full_Date}
            </span>
            <h2 className="section-title__title">{filteredGallery?.title}</h2>
          </div>
          <h6 className="back-to-album-h3">
            <div
              className="back-to-album"
              onClick={(e) => {
                e.preventDefault();
                window.history.back();
              }}
            >
              <i className="icon-arrow-left2 custom-arrow-left"></i>
              &nbsp; Back to Album
            </div>
          </h6>
          <div className="row">
            {!loading &&
              filteredGallery?.image.map((image, index) => (
                <div className="col-xl-3 col-lg-6 col-md-6" key={index}>
                  <Fade
                    key={index}
                    cascade
                    damping={0.2} 
                    triggerOnce={true}
                    delay={index * 200}
                  >
                    <div className="events__single">
                      <div
                        className="events__img custom-events_img"
                        style={{
                          position: "relative",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSlideClick(index)}
                      >
                        <img
                          src={`${process.env.REACT_APP_strapiUrl}${image}`}
                          alt="gallery-image"
                          style={{
                            objectFit: "cover",
                            // height: "200px",
                            height: "255px",
                          }}
                        />
                      </div>
                    </div>
                  </Fade>
                </div>
              ))}
          </div>
        </div>
      </section>
      <Lightbox
        open={open}
        plugins={[
          Counter,
          Fullscreen,
          //   Share,
          Slideshow,
          Video,
          Zoom,
          Thumbnails,
        ]}
        close={() => setOpen(false)}
        slides={lightboxSlides}
        index={lightboxIndex}
      />
    </>
  );
};

export default GalleryImage;
